import { Fragment } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { CustomisedNavbarMenuItem } from './CustomisedNavbarMenuItem';

export type CustomisedNavbarMenuItemsProps = {
  items: any[];
  disabledAction: boolean;
  firstName: string;
  iconMapper: Record<string, string>;
  checkNavItemVisibility: (item: any) => boolean;
  onLinkClick: (item: any) => void;
  navigate: (url: string) => void;
  logout: () => void;
  exitIconSrc: string;
};

export const CustomisedNavbarMenuItems = ({
  items,
  disabledAction,
  firstName,
  iconMapper,
  checkNavItemVisibility,
  onLinkClick,
  navigate,
  logout,
  exitIconSrc,
}: CustomisedNavbarMenuItemsProps) => {
  return (
    <>
      {items.map((item: any, index: number) => (
        <Fragment key={`nav-${item.id}-${index}`}>
          {item.dividerOnLeft ? <NavDropdown.Divider /> : null}
          <CustomisedNavbarMenuItem
            item={item}
            disabledAction={disabledAction}
            firstName={firstName}
            iconMapper={iconMapper}
            checkNavItemVisibility={checkNavItemVisibility}
            onLinkClick={onLinkClick}
            navigate={navigate}
            logout={logout}
            exitIconSrc={exitIconSrc}
          />
        </Fragment>
      ))}
    </>
  );
};
